module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5c8pG"))).then(() => parcelRequire('d0iPb'));